import { useState } from "react";
import { isEmpty, startCase } from "lodash";
import dayjs from "dayjs";
import { AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import { apiPut } from "../../../utils/apiFetch";
import apiPath from "../../../utils/pathObj";
import useToastContext from "hooks/useToastContext";
import classNames from "classnames";
import RequestAccept from "./RequestAccept";
import RejectReply from "./RejectReply";

const Table = ({ requestList, handleRequestView, allRequest, user, page, setPage, sort, setSort }) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const [currentItem, setCurrentItem] = useState("");
  const [rejectItem, setRejectItem] = useState("");
  const [jobRequest, setJobRequest] = useState("");
  const [jobApply, setJobApply] = useState({});
  const [replyShowModal, setReplyShowModal] = useState(false);

  const handleRequestAccept = (item) => {
    setCurrentItem(item);
    setJobRequest(!jobRequest);
    setJobApply({
      _id: item.Employee?._id,
    });
  };

  const handelReply = (item) => {
    setRejectItem(item);
    setReplyShowModal(true);
    setJobApply({
      _id: item.Employee?._id,
    });
  };

  const changeStatus = async (item) => {
    try {
      const payload = {
        status: item?.status,
        employeeID: item?._id,
        companyID: item?.companyID,
      };
      const path = `${apiPath.ChangeStatusJob}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allRequest();
      } else {
        notification.error(result?.data?.message);
      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                Sr no.
              </th>
              <th scope="col" className="py-3 px-6">
                {t("EMPLOYEE_NAME")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("JOB_TITLE")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("DEPARTMENT")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("YEAR_OF_EXPERIENCE")}
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-start">
                  <span>{t("JOB_APPLIED_DATE")}</span>
                  <span>
                    {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {requestList &&
              requestList?.map((item, i) => (
                <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-4 px-6 border-r text-gray-900 text-left">{item?.Employee?.name}</td>
                  <td className="py-4 px-6 border-r text-gray-900 text-left">{item?.Job?.name}</td>
                  <td className="py-4 px-6 border-r text-gray-900 text-left">{item?.JobDepartment?.name}</td>
                  <td className="py-4 px-6 border-r text-gray-900 text-left">{item?.yearOfExperiece} </td>
                  <td className="py-4 px-6 border-r text-gray-900 text-left">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")} </td>
                  <td className="py-4 px-6 border-l text-gray-900">
                    <div className="">
                      <ul className="flex justify-center items-center">
                        <li onClick={() => handleRequestView(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                          <a title={t("O_VIEW_USER")}>
                            {" "}
                            <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                          </a>
                        </li>
                        {item?.status === "pending" ? (
                          <>
                            <span title="Accept request" className="text-green-600 cursor-pointer" onClick={() => handleRequestAccept(item)}>
                              {startCase("accept")}
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
                            <span title="Reject request" className="text-red-600 cursor-pointer" onClick={() => handelReply(item)}>
                              {startCase("reject")}
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                        {item?.status !== "pending" ? (
                          <span
                            title={startCase(item.status)}
                            className={classNames({
                              "text-green-600": item.status === "accepted",
                              "text-red-600": item.status === "rejected",
                            })}
                          >
                            {" "}
                            {startCase(item.status)}{" "}
                          </span>
                        ) : null}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(requestList) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
      <>{jobRequest ? <RequestAccept setJobRequest={setJobRequest} currentItem={currentItem} changeStatus={changeStatus} allRequest={allRequest} setPage={setPage} jobApply={jobApply} /> : null}</>
      {replyShowModal ? <RejectReply setReplyShowModal={setReplyShowModal} rejectItem={rejectItem} changeStatus={changeStatus} allRequest={allRequest} setPage={setPage} jobApply={jobApply} /> : null}
    </div>
  );
};

export default Table;
